import { useSnackbar } from 'notistack'
import React from 'react'

const InnerSnackbarUtilsConfigurator = (props) => {
    props.setUseSnackbarRef(useSnackbar())
    return null
}

let useSnackbarRef
const setUseSnackbarRef = (useSnackbarRefProp) => {
    useSnackbarRef = useSnackbarRefProp
}

export const SnackbarUtilsConfigurator = () => {
    return <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />
}

/**
 * `msg` may be a string or a React node - notistack renders either. The second
 * argument is passed straight through to enqueueSnackbar, which is how a caller
 * asks for a longer autoHideDuration when the message is a list the reader has
 * to work through rather than a single line.
 */
export default {
    success(msg, options) {
        this.toast(msg, 'success', options)
    },
    warning(msg, options) {
        this.toast(msg, 'warning', options)
    },
    info(msg, options) {
        this.toast(msg, 'info', options)
    },
    error(msg, options) {
        this.toast(msg, 'error', options)
    },
    toast(msg, variant = 'default', options = {}) {
        useSnackbarRef.enqueueSnackbar(msg, { variant, ...options })
    }
}